import { useRef, useState } from 'react';
import styled from '@emotion/styled';
import WithPreviewImage from '@comp/Question/WithPreviewImage/WithPreviewImage';
import useQuestion from '@cont/Quiz/Taking/Objective/Question/useQuestion';
import { ntaPageCss } from '../typography';
import NtaComprehensionView from './NtaComprehensionView';
import NtaObjectiveQuestion from './NtaObjectiveQuestion';
import NtaQuestionActions from './NtaQuestionActions';
import NtaQuestionScroll from './NtaQuestionScroll';
import NtaQuestionTitleRow from './NtaQuestionTitleRow';

const Panel = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px 0 0 24px;
  border-radius: 12px;
  ${ntaPageCss}
`;

const NtaQuestionView = () => {
  const { currentQuestion, currentLanguage, questionUID } = useQuestion();
  const scrollRef = useRef(null);
  const [scrollMetrics, setScrollMetrics] = useState({
    canScroll: false,
    atBottom: true
  });

  const hasComprehension =
    !!currentQuestion?.comprehension?.[currentLanguage?.code];

  if (!currentQuestion?.uid) {
    return null;
  }

  if (hasComprehension) {
    return <NtaComprehensionView />;
  }

  return (
    <Panel>
      <NtaQuestionTitleRow
        onScrollToBottom={() => scrollRef.current?.scrollToBottom()}
        showScrollToBottom={scrollMetrics.canScroll && !scrollMetrics.atBottom}
      >
        Question {currentQuestion.question_rank}:
      </NtaQuestionTitleRow>
      <NtaQuestionScroll
        ref={scrollRef}
        scrollKey={questionUID}
        showScrollNav
        onScrollMetricsChange={setScrollMetrics}
      >
        <WithPreviewImage>
          <NtaObjectiveQuestion />
        </WithPreviewImage>
      </NtaQuestionScroll>
      <NtaQuestionActions />
    </Panel>
  );
};

export default NtaQuestionView;
